module.exports = __webpack_public_path__ + "static/img/lifestyle_16.37453b90.jpg";